import { AvailableFilter } from './top-search.interface';

// ToDo remove this after lints updates
declare var essity: any;

export default (items: AvailableFilter[]) => {
  const categoryNames = items.reduce((acc, filter: AvailableFilter) => {
    const name = filter.displayName.split('-')[0];
    const update = [...acc, name];
    return update.filter((categoryName, pos) => {
      return update.indexOf(categoryName)== pos;
    })
  }, []);

  return `${categoryNames.reduce((acc, category: string) => {
    const button = `<button class="btn btn--tab js-filter-button ${category === 'All' ? 'active': ''}" data-value="${category}">${essity?.filters?.search[category]}</button>`;
    const updatedAcc = acc + button;
    return updatedAcc;
  }, '')}`
};
